import React from 'react';
import { connect } from 'react-redux';
import Form from './components/forms/form';
import LazyComponentWrapper from './components/common/LazyComponentWrapper';
import { lazyWithRetry } from './utils/lazyWithRetry';

const ChatForm = lazyWithRetry(
  () =>
    import(/* webpackChunkName: "chatform" */ './components/forms/formChat'),
  'chatform'
);

class App extends React.Component {
  componentDidMount() {
    document.getElementsByTagName('body')[0].classList.remove('bodyReset');
  }

  render() {
    return window.chatform ? (
      <LazyComponentWrapper component={ChatForm} source="App:ChatForm" />
    ) : (
      <Form />
    );
  }
}

export default connect()(App);
